import React, { ChangeEvent } from 'react';

export interface IOption {
  title: string;
  value: string | number;
}

interface Props {
  style?: React.CSSProperties;
  options: IOption[];
  value?: any;
  title?: string;
  className?: string;
  isDisabled?: boolean;
  onChange: (e: ChangeEvent<any>) => void;
}

const createOptions = (option: IOption) => (
  <option id={`selectinput-createoptions-${option.value}-${option.title}`} value={option.value}>{option.title}</option>
);

const selectInput = (props: Props) => {
  const { options, value, onChange, isDisabled, ...rest } = props;
  const selectedOption = options?.find((op) => op.value == value);
  const titleText = selectedOption ? selectedOption.title : '';
  return (
    <select
      id='selectinput-wrapper'
      disabled={isDisabled}
      title={titleText}
      value={value}
      onChange={onChange}
      {...rest}
    >
      {options?.map((option) => createOptions(option))}
    </select>
  );
};

export default selectInput;
